import { registerArchetype } from './index.js';
import { livingEnemies, enemySide, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'silence',
    apply: ({ state, source, params }) => {
        const duration = params.duration ?? 3;
        const target = params.target ?? 'lowest_hp';
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const targets = target === 'all_enemies'
            ? enemies
            : [enemies.reduce((m, e) => e.runtime.hp < m.runtime.hp ? e : m)];
        const enemyKey = enemySide(source.side);
        for (const t of targets) {
            getRuntimes(state, enemyKey)[t.slot].statuses.push({
                id: `silence_${state.tick}_${t.slot}`,
                kind: 'silence', remainingTicks: duration, params: {}
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: enemyKey, slot: t.slot, status: 'silence', duration });
        }
    }
});
